/**
 * @desc 删除
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(quotationInfoId: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotationZone/delete/all/${quotationInfoId}`, {
      method: "DELETE",

      ...options,
    }),
  );
}
